type DayCapacity = { capacity: number };

type WeeklyCalendar = {
  monday: DayCapacity;
  tuesday: DayCapacity;
  wednesday: DayCapacity;
  thursday: DayCapacity;
  friday: DayCapacity;
  saturday: DayCapacity;
  sunday: DayCapacity;
};

const dayCapacity: DayCapacity = {
  capacity: 0,
};

const weeklyCalendar: WeeklyCalendar = {
  friday: dayCapacity,
  monday: dayCapacity,
  saturday: dayCapacity,
  sunday: dayCapacity,
  thursday: dayCapacity,
  tuesday: dayCapacity,
  wednesday: dayCapacity,
};

export type { WeeklyCalendar, DayCapacity };

export { dayCapacity, weeklyCalendar };
